(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var formErrorsDelegate = require('./app/lib/form-errors-delegate')()
  , performLogin = require('./lib/perform-login')
  , apiUrl = $('.js-config').data('api-url')

// Needs to fudge a context
formErrorsDelegate.$ = $

module.exports = twoFaClickHandler

function twoFaClickHandler (data) {
  formErrorsDelegate.clearErrors()

  var postData = {
    code: $('input[name=code]').val()
  , remember: $('input[name=rememberTwoFa]').is(':checked')
  , adminId: data.id
  , hash: data.twoFaHash
  , fingerprint: data.fingerprint
  }

  $.ajax({
    type: 'POST'
  , url: apiUrl + '/verify-two-fa'
  , data: JSON.stringify(postData)
  , success: function (data) {
      if (data.key) {
        performLogin(data)
      } else {
        $('.js-errors-summary').html(data)
      }
    }
  , context: this
  , error: function (error) {
      var parseError = JSON.parse(error.responseText)
      if (parseError.errors) {
        formErrorsDelegate.showErrors(parseError.errors)
      } else {
        formErrorsDelegate.showErrors(parseError)
      }
    }
  , dataType: 'json'
  , contentType: 'application/json'
  })
  return false
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/two-fa.js","/admin/source/js")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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